import { BENEFITS } from "../mock";
import { Reveal } from "./Reveal";

export const Benefits = () => (
  <section id="benefici" data-testid="benefits-section" className="bg-white py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <span className="text-[#c8102e] font-condensed font-bold uppercase tracking-widest text-sm">I vantaggi</span>
        <h2 className="font-condensed font-extrabold uppercase tracking-tight text-[#191512] text-3xl sm:text-4xl mt-2">
          Una casa e un ufficio che funzionano, <span className="text-[#c8102e]">senza doverci pensare tu</span>
        </h2>
      </Reveal>
      <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.12}>
            <div
              data-testid={`benefit-card-${i}`}
              className="group h-full bg-[#faf7f2] rounded-2xl p-8 border border-slate-100 shadow-sm transition-all duration-300 hover:-translate-y-1.5 hover:shadow-xl hover:border-[#c8102e]/25"
            >
              <span className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#c8102e] text-white mb-6 transition-colors duration-300 group-hover:bg-[#1b7a46]">
                <b.icon className="w-7 h-7" strokeWidth={2} />
              </span>
              <h3 className="font-condensed font-bold uppercase tracking-tight text-[#191512] text-xl sm:text-2xl">
                {b.title}
              </h3>
              <p className="mt-3 text-slate-600 text-sm sm:text-base leading-relaxed">{b.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
